<template>
    <div class="task_main">

        <!-- <signView :taskList="checkinList"></signView> -->

        <div class="userXp">
            <div class="userXp_layout">

                <div class="top_us">

                    <div class="task_left_colunm_layout">
                        <div class="xp_title">My XP</div>
                        <div class="my_xp_layout">
                            <div class="xp_num">{{ xpNumber }}</div>
                            <div class="bee_xpTop_logo"></div>
                        </div>

                    </div>

                    <div v-if="isLoad == false">
                        <div class="task_send" v-if="!isLoading" @click="login()">
                            Login
                        </div>
                        <div v-else>
                            <div class="task_loading">
                                <div class="loading_logo"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="xp_logo">
                </div>
            </div>
        </div>

        <div id="rx_telegram_layout" class="shadow_tg">
        </div>
        <div class="task_tab_layout" :style="{ opacity: `${opacityNumber}` }">
            <div v-for="(item, index) in taskList" :key="index" class="item_layout">

                <div class="tsk_div_row">
                    <div class="index_task"></div>
                    <div class="item_task_type">
                        {{ item.name }}
                    </div>
                </div>


                <div v-if="item.name == 'Daily Task'">

                    <div class="home_task_item_layout">

                        <img src="https://www.bee.com/wp-content/uploads/2024/11/20241127-152135-1.png"
                            class="bee_task_logo" @error="taskLogoErr(index)">

                        <div class="task_left_colunm_layout">
                            <div class="task_title">Continuous check-in</div>
                            <div class="task_left_row_layout">
                                <div class="task_reward_txt">+{{ xpCheckInToday }}</div>
                                <div class="bee_experience_logo" />
                            </div>
                        </div>

                        <div v-if="isTodaySign" class="task_claimed_send" @click="doCheckTask()">
                            <div>Claimed</div>
                            <div class="status_Done"></div>
                        </div>
                        <div v-else class="task_send" @click="doCheckTask()">
                            Start
                        </div>

                    </div>

                    <div class="home_task_item_layout" v-show="false"> <img
                            src="https://www.bee.com/wp-content/uploads/2024/11/invite_frend.png" class="bee_task_logo"
                            @error="taskLogoErr(index)">

                        <div class="task_left_colunm_layout">
                            <div class="task_title">Invite Frends</div>
                            <div class="task_left_row_layout">
                                <div class="task_reward_txt">+10000</div>
                                <div class="bee_experience_logo"></div>
                            </div>
                        </div>

                        <div v-if="isCompletInvite" class="task_claimed_send" @click="doShowInVite()">
                            <div>Claimed</div>
                            <div class="status_Done"></div>
                        </div>
                        <div v-else class="task_send" @click="doShowInVite()">
                            Start
                        </div>

                    </div>

                </div>

                <div v-for="(item, index) in item.list" :key="index">
                    <div class="home_task_item_layout">

                        <img :src="item.logoUrl" class="bee_task_logo" @error="taskLogoErr(index)">

                        <div class="task_left_colunm_layout">
                            <div class="task_title"> {{ item.title }}</div>
                            <div class="task_left_row_layout">
                                <div class="task_reward_txt">+{{ item.xp }}</div>
                                <div class="bee_experience_logo"></div>
                            </div>

                        </div>

                        <div v-if="item.isLoad" class="task_loading">
                            <div class="loading_logo"></div>
                        </div>
                        <div v-else>

                            <div v-if="item.participate">

                                <div v-if="item.claimed" class="task_claimed_send" @click="endTask(item)">
                                    <div>Claimed</div>
                                    <div class="status_Done"></div>
                                </div>
                                <div v-else>
                                    <div v-if="item.verified" class="task_send_success" @click="doClaimTask(item)">
                                        <div>Claim</div>
                                        <div class="status_claim"></div>
                                    </div>

                                    <div v-else class="task_verify" @click="inWebVerifyTask(item)">
                                        Check
                                    </div>

                                </div>

                            </div>
                            <div v-else>
                                <div class="task_send" @click="doTask(item)">
                                    Start
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    baseUrl, test_twitter_auth_url, discord_auth_url, tgBotName
} from "../../util/mock.js"
import { AccountStore } from "../../util/Account.js";
import signView from "./sign.vue";
import Toast from "../../components/message.js";
import { addEmit, resultEmitEvent } from "../../util/event";

export default {
    name: 'taskView',
    props: {
        taskList: [],
        checkinList: [],
        isTodaySign: false,
        xpNumber: 0,
        xpCheckInToday: 0,
        opacityNumber: 0.5,
        isLoad: true,
    },
    emits: ["checkInClick"],
    components: { signView },
    data() {
        return {
            // taskList: [{ "taskId": 5, "title": "Telegram", "content": "bind tg", "url": "https://www.bee.com", "xp": 20.00, "logoUrl": "https://static.bee.com/images/21224341b97301d088b46a273aa1be98-0000001923.png", "taskType": "OnceTask", "participate": false, "verified": false, "claimed": false, "createTime": 1727420697822, "updateTime": 1727420697822 }, { "taskId": 4, "title": "Discord", "content": "bind dc", "url": "https://www.bee.com", "xp": 20.00, "logoUrl": "https://static.bee.com/images/6fc971a1dc28463adfc37e9fd42c313f-0000007375.png", "taskType": "OnceTask", "participate": false, "verified": false, "claimed": false, "createTime": 1727420669146, "updateTime": 1727420669147 }, { "taskId": 3, "title": "twitter", "content": "bind twitter", "url": "https://www.bee.com", "xp": 20.00, "logoUrl": "https://static.bee.com/images/9a73a062abc4286648ad9b33c4349709-0000002253.png", "taskType": "OnceTask", "participate": false, "verified": false, "claimed": false, "createTime": 1727420579101, "updateTime": 1727420579101 }, { "taskId": 2, "title": "转发twitter", "content": "转发twitter 详情", "url": "https://www.bee.com", "xp": 5.00, "logoUrl": "https://static.bee.com/images/21224341b97301d088b46a273aa1be98-0000001923.png", "taskType": "OnceTask", "participate": false, "verified": false, "claimed": false, "createTime": 1727344251280, "updateTime": 1727344251280 }, { "taskId": 1, "title": "每日任务", "content": "浏览官网", "url": "https://www.bee.com", "xp": 5.00, "logoUrl": "https://static.bee.com/images/b8dc5cdeb16cfec6f7f4fa19a4e08fcb-0000009009.png", "taskType": "MustTask", "participate": false, "verified": false, "claimed": false, "createTime": 1727343747255, "updateTime": 1727343747255 }],
            tabIndex: 0,
            tgJs: "",
            itemTask: {},
            loginUrl: "",
            // isLoad: false,
            // opacityNumber: 0.5,
            // xpNumber: "0"
            // taskList: [],
            isClick: false,
            isLoading: false,
            isCompletInvite: false,
        }
    },

    watch: {

    },

    methods: {
        async endTask(item) {
            if (item.taskType == "ReferralTask") {
                let view = document.getElementById("bee_nInvite");
                view.style.display = "flex";
                return;
            }
            if (this.getDevIsMobile()) {
                window.location.href = item.url;
            } else {
                let jWindow = window.open("", "_blank");
                if (jWindow) {
                    jWindow.location.href = item.url;
                } else {
                    window.location.href = item.url;
                }
            }
        },

        async doTask(item) {
            if (this.isLoad == false) {
                // Toast("Please login first", "error");
                return;
            }

            if (AccountStore.accountInfo == null) {
                Toast("Please login first", "error");
                return;
            }
            // console.log(AccountStore.accountBindInfo)
            // console.log(AccountStore.accountBindInfo.twitterId)
            // console.log(item.url + "====item.url")
            // if ((AccountStore.accountBindInfo.twitterId == null || AccountStore.accountBindInfo.twitterId == undefined)
            //     && (item.url.indexOf("x.com") != -1 || item.url.indexOf("twitter.com") != -1)) {
            //     window.location.href = test_twitter_auth_url;
            //     return;
            // }
            // console.log(AccountStore.accountBindInfo.dcId)
            // if ((AccountStore.accountBindInfo.dcId == null || AccountStore.accountBindInfo.dcId == undefined)
            //     && (item.url.indexOf("discord.com") != -1)) {
            //     window.location.href = discord_auth_url;
            //     return;
            // }
            // if ((AccountStore.accountBindInfo.dcId == null || AccountStore.accountBindInfo.dcId == undefined)
            //     && (item.url.indexOf("discord.gg") != -1)) {
            //     window.location.href = discord_auth_url;
            //     return;
            // }
            // console.log(AccountStore.accountBindInfo.tgId)
            // if ((AccountStore.accountBindInfo.tgId == null || AccountStore.accountBindInfo.tgId == undefined) &&
            //     (item.url.indexOf("telegram.") != -1 || item.url.indexOf("t.me") != -1)) {
            //     // this.onTgLogin();
            //     // TWidgetLogin.auth();
            //     return;
            // }

            if (this.isClick) {
                return;
            }
            this.isClick = true;
            item.isLoad = true;

            var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_doTask',
                    taskId: item.taskId,
                    userInfo: e_mail,
                }),
            };

            const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();
            const taskData = data.data.data;
            // console.log(taskData)

            if (item.taskType == "ReferralTask") {
                let view = document.getElementById("bee_nInvite");
                view.style.display = "flex";
                this.isClick = false;
                addEmit("verifyTask", item.xp);
                return;
            }

            if (item.taskType == "DailyTask") {
                await this.inWebVerifyTask(item);
            }

            if (this.getDevIsMobile()) {
                window.location.href = item.url;
            } else {
                let jWindow = window.open("", "_blank");
                if (jWindow) {
                    jWindow.location.href = item.url;
                } else {
                    window.location.href = item.url;
                }
            }
            // window.open(item.url, "_blank");
            // await this.verifyTask(item);
            // window.location.href = item.url;
            addEmit("verifyTask", item.xp);
            this.isClick = false;
        },

        async verifyTask(item) {
            var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_verifyTask',
                    taskId: item.taskId,
                    userInfo: e_mail,
                }),
            };

            const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();
            const verifyData = data.data.data;
            // console.log(verifyData)
        },

        taskLogoErr(index) {
            // this.taskList[index].logoUrl = "../../assets/logo.png"
        },

        onTwitterLogin() {
            window.location.href = test_twitter_auth_url;
        },
        onDiscordLogin() {
            window.location.href = discord_auth_url;
        },
        onTgLogin() {
            var telegram_layout = document.getElementById('rx_telegram_layout')
            var script = document.createElement("script");
            script.src = this.tgJs;
            script.setAttribute('data-telegram-login', tgBotName)
            script.setAttribute('data-size', 'large')
            script.setAttribute('data-onauth', 'onTelegramAuth(user)')
            script.setAttribute('data-request-access', 'write')
            script.async = true
            telegram_layout.appendChild(script);
            this.scriptCount = true
            // Toast("提交成功", "success");
        },
        async getTgJsPath() {
            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
            };

            const tgPathInfo = localStorage.getItem("tgJs", null);
            if (tgPathInfo != "" && tgPathInfo != undefined) {
                const tginfo = JSON.parse(tgPathInfo);
                this.loginUrl = tginfo.loginUrl;
                this.tgJs = tginfo.data;
                return;
            }
            const ajaxData = await fetch(`${baseUrl()}/wp-json/beeTask/v1/jspath`, options)
            let data = await ajaxData.json();
            this.tgJs = data.data.data;
            this.loginUrl = data.data.loginUrl;

            localStorage.setItem("tgJs", JSON.stringify(data.data));

            // console.log(this.tgJs)
            // this.onTgLogin();
        },

        async inWebDoTask(item) {
            var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            item.isLoad = true;
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_doTask',
                    taskId: item.taskId,
                    _wpnonce: "wp_nonce",
                    userInfo: e_mail,
                }),
            };
            const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();
            // console.log(data);

            await this.inWebVerifyTask(item);
            window.location.href = item.url;
        },
        async inWebVerifyTask(item) {
            var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            item.isLoad = true;
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_verifyTask',
                    userId: 0,
                    taskId: item.taskId,
                    _wpnonce: "wp_nonce",
                    userInfo: e_mail,
                }),
            };
            const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();

            let wp_data = data.data.data;
            let json = JSON.parse(wp_data);
            if (json.data == false) {
                if (item.taskType == "ReferralTask") {
                    let view = document.getElementById("bee_nInvite");
                    view.style.display = "flex";
                    this.isClick = false;
                    addEmit("verifyTask", item.xp);
                    return;
                }
            }
            // console.log(data)
            addEmit("verifyTask", item.xp);
        },

        async doClaimTask(item) {
            var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            item.isLoad = true;
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_claimTask',
                    userId: 0,
                    taskId: item.taskId,
                    _wpnonce: "wp_nonce",
                    userInfo: e_mail,
                }),
            };
            const ajaxData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            let data = await ajaxData.json();
            // console.log(data)
            let wp_data = data.data.data;
            try {
                let json = JSON.parse(wp_data);
                if (json.code == 200) {
                    // console.log(data);
                    addEmit("verifyTask", item.xp);
                } else {
                    Toast(json.message, "error");
                }
            } catch (error) {
                addEmit("verifyTask", item.xp);
                Toast(wp_data, "error");
            }
        },

        async doCheckTask() {
            if (this.isLoad == false) {
                return;
            }
            this.$emit("checkInClick");
        },

        async checkLogin() {
            await AccountStore.fetchUserInfo();
            // this.isLoad = AccountStore.isUserLoginStatus;
            // if (this.isLoad) {
            //     this.opacityNumber = 1;
            // } else {
            //     this.opacityNumber = 0.5;
            // }
        },
        login() {
            this.isLoading = true;
            window.location.href = "https://www.bee.com/wp-login.php?external=oauth2";
        },
        tgClick() {

        },
        getDevIsMobile() {
            let md = 768;
            let screenWidth = window.screen.width;
            let isMobile = screenWidth < md;
            return isMobile;
        },
        doShowInVite() {
            let view = document.getElementById("bee_nInvite");
            view.style.display = "flex";
        }

    },

    mounted() {

        this.getTgJsPath();
        // this.get_wp_task();
    },


}

</script>

<style scoped>
.task_main {
    min-height: 380px;
    display: flex;
    /* margin-top: 12px; */
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    max-height: 500px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
    max-width: 320px;
}

@media (max-width:767.98px) {
    .task_main {
        min-height: 380px;
        display: flex;
        /* margin-top: 12px; */
        flex-direction: column;
        width: -webkit-fill-available;
        width: -moz-available;
        max-height: 400px;
        max-width: 320px;
    }
}

.task_tab_layout {
    border-radius: 8px;
    border: 1px #000;
    display: flex;
    flex-direction: column;
    max-height: 400px;
    overflow: overlay;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-left: 12px;
    margin-right: 12px;
}

.home_task_item_layout {
    margin-top: 8px;
    border: 1px #000;
    background: #FFF;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.14px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bee_task_logo {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-right: 6px;
    background: #ffc04d;
}

.bee_experience_logo {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-left: 2px;
    background-image: url("../../assets/icon_task_reward_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
}

.bee_xpTop_logo {
    width: 26px;
    height: 26px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-left: 2px;
    background-image: url("../../assets/icon_task_reward_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 4px;
}


.task_left_colunm_layout {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.task_left_row_layout {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
}

.task_title {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: start;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 18px;
    max-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
}

.task_reward_txt {
    color: #666666;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.task_send {
    cursor: pointer;
    border-radius: 30px;
    background: #FFAE00;
    color: #FFF;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-top: 4px;
    padding-bottom: 4px;
    width: 80px;
}

.task_send_success {
    cursor: pointer;
    border-radius: 30px;
    background: #C6FFE7;
    color: #00C170;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.task_claimed_send {
    cursor: pointer;
    border-radius: 30px;
    background: #F2F1EF;
    color: #D4D1C9;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    /* 166.667% */
    letter-spacing: 0.12px;
    padding-top: 4px;
    padding-bottom: 4px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 80px;
}

.ms-scrollbar {
    background-color: #f1f1f1;
}

/* 修改滚动条滑块的颜色 */
.ms-scrollbar-thumb {
    background-color: #f1f1f1;
}

/* 修改滑块悬停时的颜色 */
.ms-scrollbar-thumb:hover {
    background-color: #f1f1f1;
}

/* 修改滚动条轨道的颜色 */
.ms-scrollbar-track {
    background-color: #f1f1f1;
}

::-webkit-scrollbar {
    width: 5px;
    background-color: #f9f9f9;
}

::-webkit-scrollbar-track {
    background-color: #e1e1e1;
    border-radius: 10px;
}

.item_task_type {
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.item_layout {
    background: #fff;
    border-radius: 12px;
    margin-bottom: 12px;
    padding: 12px;
}

.userXp {
    margin-top: 6px;
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 2px;
}

.userXp_layout {
    margin-top: 8px;
    text-align: center;
    -webkit-text-stroke-width: 1;
    -webkit-text-stroke-color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.14px;
    flex-direction: row;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.xp_logo {
    width: 73px;
    height: 66px;
    background-image: url("../../assets/xp_logo.png");
    background-size: cover;
    background-repeat: no-repeat;
    display: none;
}

.status_Done {
    width: 12px;
    height: 12px;
    background-image: url("../../assets/icon_claim.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: 2px;
}

.status_claim {
    width: 12px;
    height: 12px;
    background-image: url("../../assets/icon_claim_start.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: 4px;
    display: none
}

.xp_title {
    display: flex;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.32px;
    color: #666666;
}

.xp_num {
    font-size: 30px;
    font-weight: 500;
    line-height: 36.33px;
    letter-spacing: 0.01em;
    color: #000;
}

.index_task {
    width: 2px;
    height: 13px;
    background-color: #FFC04D;
    margin-right: 4px;
}

.tsk_div_row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.shadow_tg {
    justify-content: center;
    padding-bottom: 10px;
    align-items: center;
    margin-left: 16px;
    width: 52px;
    height: 28px;
    display: none;
}

.my_xp_layout {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-bottom: 8px;
}

.top_us {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    width: -webkit-fill-available;
    width: -moz-available;
    padding-right: 8px;
}

.task_loading {
    border-radius: 30px;
    background: #FFE7B3;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 28px;
}

.loading_logo {
    width: 18px;
    height: 18px;
    background-image: url("https://www.bee.com/wp-content/uploads/2025/03/loading.gif");
    background-size: cover;
    background-repeat: no-repeat;
    /* animation: rotate 2s linear infinite; */
}

.task_verify {
    border-radius: 30px;
    background: #FFE7B3;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 28px;
    color: #F29100;
    cursor: pointer;

}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>